// tslint:disable:variable-name
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, observable, Observable, of, Subscription } from 'rxjs';
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';
import { PaginatorState } from '../models/paginator.model';
import { ITableState, ITableStateApplyedQuranKaremExam, ITableStateCourseStudent, ITableStateExamQustion, ITableStateProduct, ITableStateQuranKarem, ITableStateQustion, ResponseModel, TableResponseModel } from '../models/table.model';
import { BaseModel } from '../models/base.model';
// import { GroupingState } from '../models/grouping.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from '../i18n/translation.service';
import { environment } from 'src/environments/environment.prod';

const DEFAULT_STATE: ITableState = {
  // filter: {},
  paginator: new PaginatorState(),
  searchTerm: '',
  langId: 0
};
const DEFAULT_STATEProduct: ITableStateProduct = {
  // filter: {},
  paginator: new PaginatorState(),
  searchTerm: '',
  langId: 0,
  isParent: false,
  parentId: ''
};
const DEFAULT_STATEQuestion: ITableStateQustion = {
  paginator: new PaginatorState(),
  langId: 0,
  questionReferenceId: ''
};
const DEFAULT_STATEExamQuestion: ITableStateExamQustion = {
  paginator: new PaginatorState(),
  langId: 0,
  examId: ''
};
const DEFAULT_STATEApplyedQuranKaremExam: ITableStateApplyedQuranKaremExam = {
  paginator: new PaginatorState(),
  langId: 0,
  courseId: ''
};
const DEFAULT_STATECourseStudent: ITableStateCourseStudent = {
  paginator: new PaginatorState(),
  langId: 0,
  courseId: ''
};
const DEFAULT_STATEQuranKarem: ITableStateQuranKarem = {
  // filter: {},
  paginator: new PaginatorState(),
  // sorting: new SortState(),
  searchTerm: '', studentId: '',
  langId: 0,
  isParent: false,
  parentId: '',
  stageId: '',
  courseId: '',
  lessonId: '',
  levelId: '',
  branchId: '',
  teacherId: '',
  examId: '',
  roleId: '',
  questionReferenceId: ''
};

export abstract class BaseService<T> {
  // Private fields

  private _items$ = new BehaviorSubject<T[]>([]);
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  private _isFirstLoading$ = new BehaviorSubject<boolean>(true);
  private _tableState$ = new BehaviorSubject<ITableState>(DEFAULT_STATE);
  private _tableStateProduct$ = new BehaviorSubject<ITableStateProduct>(DEFAULT_STATEProduct);
  private _tableStateQuranKarem$ = new BehaviorSubject<ITableStateQuranKarem>(DEFAULT_STATEQuranKarem);
  private _tableStateCourseStudent$ = new BehaviorSubject<ITableStateCourseStudent>(DEFAULT_STATECourseStudent);
  private _tableApplyedQuranKaremExam$ = new BehaviorSubject<ITableStateApplyedQuranKaremExam>(DEFAULT_STATEApplyedQuranKaremExam);
  private _tableStateQurstion$ = new BehaviorSubject<ITableStateQustion>(DEFAULT_STATEQuestion);
  private _tableStateExamQurstion$ = new BehaviorSubject<ITableStateExamQustion>(DEFAULT_STATEExamQuestion);
  private _errorMessage = new BehaviorSubject<string>('');
  private _subscriptions: Subscription[] = [];

  // Getters
  get items$() {
    return this._items$.asObservable();
  }
  get isLoading$() {
    return this._isLoading$.asObservable();
  }
  get isFirstLoading$() {
    return this._isFirstLoading$.asObservable();
  }
  get errorMessage$() {
    return this._errorMessage.asObservable();
  }
  get subscriptions() {
    return this._subscriptions;
  }
  // State getters
  get paginator() {
    return this._tableState$.value.paginator;
  }
  // get filter() {
  //   return this._tableState$.value.filter;
  // }
  // get sorting() {
  //   return this._tableState$.value.sorting;
  // }
  get searchTerm() {
    return this._tableState$.value.searchTerm;
  }
  // get grouping() {
  //   return this._tableState$.value.grouping;
  // }
  openSocalMediaNewWindow(id: string | undefined) {
    window.open(
      id, "_blank");

  }
  createImgPath = (serverPath: string) => {
    if (serverPath)
      return `${environment.patchUrl}/${serverPath}`;
  }
  protected http: HttpClient;
  // API URL has to be overrided
  API_URL = `${environment.apiUrl}/endpoint/`;
  API_URLFind = `${environment.apiUrl}/endpoint/`;
  API_URLAdd = `${environment.apiUrl}/endpoint/`;
  API_URLUpdate = `${environment.apiUrl}/endpoint/`;
  API_URLDelete = `${environment.apiUrl}/endpoint/`;
  API_URLGetById = `${environment.apiUrl}/endpoint/`;
  API_URLGetAll = `${environment.apiUrl}/endpoint/`;

  langId: number = 1;
  constructor(http: HttpClient, public toastr: ToastrService, public translationServices: TranslationService) {
    this.http = http;
    var language = translationServices.getSelectedLanguage();
    if (language == "ar")
      this.langId = 1;
    if (language == "en")
      this.langId = 2;
    if (language == "tr")
      this.langId = 3;
  }

  // CREATE
  // server should return the object with ID

  add$(item: any): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    item.langId = this.langId
    return this.http.post<any>(this.API_URLAdd, item).pipe(
      catchError(err => {
        if (err.error.errors) {
          this.toastr.error(err.error.errors)
        }
        if (err.error.message) {
          this.toastr.error(err.error.message)
        }
        if (err.error.error) {
          this.toastr.error(err.error.error)
        }
        throw new Error('Oh no!')
      }),
      finalize(() => {
        this._isLoading$.next(false);
      })
    );
  }
  // uploadFile(item: BaseModel): Observable<BaseModel> {

  // }

  // READ (Returning filtered list of entities)
  find(tableState: ITableState): Observable<TableResponseModel<T>> {
    tableState.langId = this.langId;
    const url = `${this.API_URLFind}`;
    this._errorMessage.next('');
    return this.http.post<TableResponseModel<T>>(url, tableState).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('FIND ITEMS', err);
        return of({ items: [], total: 0 });
      })
    );
  }






  listAll$(tableState: ITableState): Observable<TableResponseModel<T>> {
    let url = `${this.API_URL}`;

    this._errorMessage.next('');
    return this.http.get<TableResponseModel<T>>(`${url}?take=1000&skip=0`,)
      .pipe(
        catchError(err => {
          this._errorMessage.next(err);
          this.toastr.error("تعذر الاتصال")
          console.error('FIND ITEMS', err);
          return of({ items: [], total: 0 });
        })
      );
  }
  getAll$(): Observable<any[]> {
    let url = `${this.API_URLGetAll}/${this.langId}/list`;
    return this.http.get<any[]>(url).pipe(
      map((body: any) => body),
      catchError(() => of())
    )
  }
  getAllPagnation$(requestPayload: any): Observable<any> {
    return this.http.post(`${this.API_URLFind}`, requestPayload);
  }
  getAllCustomQuran$(quranKaremLevelType?: number): Observable<any[]> {
    let url = `${this.API_URL}/${this.langId}/${quranKaremLevelType}`;
    return this.http.get<any[]>(url).pipe(
      map((body: any) => body),
      catchError(() => of())
    )
  }
  getAllWithOutLang$(): Observable<any[]> {
    let url = `${this.API_URLGetAll}/list`;
    return this.http.get<any[]>(url).pipe(
      map((body: any) => body),
      catchError(() => of())
    )
  }

  getById$(id: string): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URLGetById}/${id}`;
    return this.http.get<BaseModel>(url).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('GET ITEM BY IT', id, err);
        return of({ id: undefined });
      }),
      finalize(() => this._isLoading$.next(false))
    );
  }
  getAllById$(referenceId: string): Observable<any[]> {
    let url = `${this.API_URLGetAll}/${referenceId}/GetAllById`;
    return this.http.get<any[]>(url).pipe(
      map((body: any) => body),
      catchError(() => of())
    )
  }

  // UPDATE
  update$(id: string, item: any): Observable<any> {
    item.langId = this.langId
    const url = `${this.API_URLUpdate}/${id}`;
    this._isLoading$.next(true);
    this._errorMessage.next('');
    return this.http.put(url, item).pipe(
      catchError(err => {
        this.toastr.error(err.error.error)
        throw new Error('Oh no!')
      }),
      finalize(() => { this._isLoading$.next(false) })
    );
  }


  // DELETE
  delete$(id: any): Observable<any> {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const url = `${this.API_URLDelete}/${id}`;
    return this.http.delete(url).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('DELETE ITEM', id, err);
        return of({});
      }),
    );
  }


  public fetch() {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const request = this.find(this._tableState$.value)
      .pipe(
        tap((res: TableResponseModel<T>) => {
          this._items$.next(res.items);
          this.patchStateWithoutFetch({
            paginator: this._tableState$.value.paginator.recalculatePaginator(
              res.total
            ),
          });
        }),
        catchError((err) => {
          this._errorMessage.next(err);
          return of({
            items: [],
            total: 0
          });
        }),
        finalize(() => {
          this._isLoading$.next(false);
          const itemIds = this._items$.value.map((el: T) => {
            const item = (el as unknown) as BaseModel;
            return item.referenceId;
          });
          // this.patchStateWithoutFetch({
          //   grouping: this._tableState$.value.grouping.clearRows(itemIds),
          // });
        })
      )
      .subscribe();
    this._subscriptions.push(request);
  }


  public fetchById(id: string) {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const request = this.findById(this._tableState$.value, id)
      .pipe(
        tap((res: TableResponseModel<T>) => {
          this._items$.next(res.items);
          this.patchStateWithoutFetch({
            paginator: this._tableState$.value.paginator.recalculatePaginator(
              res.total
            ),
          });
        }),
        catchError((err) => {
          this._errorMessage.next(err);
          return of({
            items: [],
            total: 0
          });
        }),
        finalize(() => {
          this._isLoading$.next(false);
          const itemIds = this._items$.value.map((el: T) => {
            const item = (el as unknown) as BaseModel;
            return item.referenceId;
          });
          // this.patchStateWithoutFetch({
          //   grouping: this._tableState$.value.grouping.clearRows(itemIds),
          // });
        })
      )
      .subscribe();
    this._subscriptions.push(request);
  }
  findById(tableState: ITableState, id: string): Observable<TableResponseModel<T>> {
    tableState.langId = this.langId;
    const url = this.API_URL + `/findById/${id}`;
    this._errorMessage.next('');
    return this.http.post<TableResponseModel<T>>(url, tableState).pipe(
      catchError(err => {
        this._errorMessage.next(err);
        console.error('FIND ITEMS', err);
        return of({ items: [], total: 0 });
      })
    );
  }
  public fetchAll() {
    this._isLoading$.next(true);
    this._errorMessage.next('');
    const request = this.listAll$(this._tableState$.value)
      .pipe(
        tap((res: TableResponseModel<T>) => {
          this._items$.next(res.items);
          this.patchStateWithoutFetch({
            paginator: this._tableState$.value.paginator.recalculatePaginator(
              res.total
            ),
          });
        }),
        catchError((err) => {
          this._errorMessage.next(err);
          return of({
            items: [],
            total: 0
          });
        }),
        finalize(() => {
          this._isLoading$.next(false);
          const itemIds = this._items$.value.map((el: T) => {
            const item = (el as unknown) as BaseModel;
            return item.referenceId;
          });
        })
      )
      .subscribe();
    this._subscriptions.push(request);
  }
  public setDefaults() {
    // this.patchStateWithoutFetch({ filter: {} });
    // this.patchStateWithoutFetch({ sorting: new SortState() });
    // this.patchStateWithoutFetch({ grouping: new GroupingState() });
    this.patchStateWithoutFetch({ searchTerm: '' });
    this.patchStateWithoutFetch({
      paginator: new PaginatorState()
    });
    this._isFirstLoading$.next(true);
    this._isLoading$.next(true);
    this._tableState$.next(DEFAULT_STATE);
    this._errorMessage.next('');
  }

  // Base Methods
  public patchState(patch: Partial<ITableState>) {
    this.patchStateWithoutFetch(patch);
    this.fetch();
  }


  public patchStateWithoutFetchProduct(patch: Partial<ITableStateProduct>) {
    const newState = Object.assign(this._tableStateProduct$.value, patch);
    this._tableState$.next(newState);
  }
  public patchStateWithoutFetch(patch: Partial<ITableState>) {
    const newState = Object.assign(this._tableState$.value, patch);
    this._tableState$.next(newState);
  }
  public patchStateWithoutFetchExam(patch: Partial<ITableState>) {
    const newState = Object.assign(this._tableState$.value, patch);
    this._tableState$.next(newState);
  }


}
